module.exports = __webpack_public_path__ + "img/logo5.3d29af90.png";